/**
 * check if ALL arguments are truthy
 * @param args arbitary number and type of arguments
 */
const checkIfAllErrored = (...args: unknown[]) => !!args.reduce((acc, cur) => acc && cur, true);

/**
 * check if ANY arguments are truthy
 * @param args arbitary number and type of arguments
 */
const checkIfAnyErrored = (...args: unknown[]) => !!args.reduce((acc, cur) => acc || cur, false);

/**
 * check if SOME but NOT ALL argument(s) are truthy
 * @param args arbitary number and type of arguments
 */
const checkIfAnyErroredButNotAll = (...args: unknown[]) => checkIfAnyErrored(...args) && !checkIfAllErrored(...args);

export { checkIfAllErrored, checkIfAnyErrored, checkIfAnyErroredButNotAll };
